export type TLabel = 'main_login_block' | 'second_login_block';

export enum EStatus {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
